import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { telehealthActions } from '../../../_actions/telehealth.actions';
import { telehealthConstants } from '../../../_constants/telehealth.constants';
import { Spinner, Breadcrumb, Tabs, Tab, Button } from 'react-bootstrap';

import moment from 'moment';
import DataTable from 'react-data-table-component';
import DownloadLink from '../List/Components/DownloadLink';
import RenderProfilePicture from '../../../_helpers/profile-picture';
import { Can } from '../../../_contexts/AbilitiesContext';

class View extends Component {
  constructor(props) {
    super(props)

    this.state = {
      data: []
    }
  }

  componentDidMount() {
    this.props.dispatch(telehealthActions.getTelehealthById(this.props.match.params.id));
  }

  componentDidUpdate() {
    if (this.props.telehealth && this.state.data.length === 0) {
      this.parseResponse(this.props.telehealth);
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: telehealthConstants.RETRIEVE_TELEHEALTH_INIT })
  }

  parseResponse(telehealth) {
    const data = telehealth.questionnaire.resource.item.map(question => {
      const answers = [];
      const answered = telehealth.questionnaireResponse.resource.item.find(item => question.definition === item.definition);

      if (answered) {
        answered.answer.forEach(answer => {
          for (let valueType in answer) {
            if (valueType === 'valueBoolean') {
              answers.push(answer.valueBoolean === true ? 'Yes' : 'No');
            } else if (valueType === 'valueDate') {
              if (answer.valueDate !== null) {
                answers.push(moment(answer.valueDate).format('MM/DD/YYYY'))
              }
            } else if (valueType === 'valueString') {
              if (answer.valueString) {
                answers.push(answer.valueString);
              }
            } else if (valueType === 'valueAttachment') {
              if (answer.valueAttachment !== null) {
                answers.push(answer.valueAttachment);
              }
            } else if (answer[valueType] !== null) {
              answers.push(answer[valueType]);
            }
          }
        });
      }

      const questionData = {
        text: question.text,
        type: question.type,
        answers: answers.length ? answers : false
      }

      if (question.type === 'display') {
        questionData.links = []
        questionData.images = []

        question.extension.forEach((item) => {
          if (item.url.includes('supportLink')) {
            questionData.links.push(item.valueUri)
          } else if (item.url.includes('supportImage')) {
            questionData.images.push(item.valueUri)
          }
        })
      }

      return questionData
    });

    this.setState({ data });
  }

  render() {
    const { isRetrieving, telehealth } = this.props;

    const columns = [
      {
        name: 'Question',
        sortable: false,
        cell: question => {
          return <strong>{question.text}</strong>
        }
      },
      {
        name: 'Answer',
        sortable: false,
        cell: question => {
          if (question.type === 'display') {
            return (
              <div className='row'>
                <div className='col-12'>
                  {question.images.length === 0 && question.links.length === 0 && (
                    <span className='text-success text-uppercase'>viewed</span>
                  )}
                  {question.images.length > 0 &&
                    question.images.map((src, i) => {
                      return (
                        <div key={i} className='row my-3'>
                          <a
                            href='!#'
                            onClick={(e) => {
                              e.preventDefault()
                              window.open(src, '_blank')
                            }}
                            rel='noopener noreferrer'
                            target='_blank'
                          >
                            <img
                              src={src}
                              className='col-8 offset-2 img-thumbnail mr-1'
                              alt=''
                            />
                          </a>
                        </div>
                      )
                    })}
                  {question.links.length > 0 &&
                    question.links.map((link, i) => {
                      return (
                        <div key={i} className='row my-3'>
                          <Button
                            onClick={() => {
                              window.open(link, '_blank')
                            }}
                            rel='noopener noreferrer'
                            target='_blank'
                            variant='outline-primary'
                            className='col-8 offset-2'
                          > Click link to review
                          </Button>
                        </div>
                      )
                    })}
                </div>
              </div>
            )
          }
          if (!question.answers) {
            return <span className="text-warning text-uppercase">unanswered</span>;
          }
          if (question.type === 'attachment') {
            return question.answers.map((link, i) => {
              return <a key={i} href={link} target="_blank" rel="noopener noreferrer">
                <img
                  key={i}
                  src={link}
                  width="100px" className="img-thumbnail mr-1" alt="Upload" />
              </a>
            })
          } else {
            return question.answers.join(', ');
          }
        }
      }
    ]

    if (isRetrieving) {
      return <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>;
    }

    return <div className="row">

      {telehealth.eventId &&
        <Breadcrumb className="col-12">
          <Breadcrumb.Item><Link to="/events">Events</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to={`/events/${telehealth.eventId}/details`}>Event Details</Link></Breadcrumb.Item>
          <Breadcrumb.Item active>View Telehealth</Breadcrumb.Item>
        </Breadcrumb>}

      {!telehealth.eventId &&
        <Breadcrumb className="col-12">
          <Breadcrumb.Item><Link to="/telehealth">Telehealth</Link></Breadcrumb.Item>
          <Breadcrumb.Item active>View Telehealth</Breadcrumb.Item>
        </Breadcrumb>}

      <div className="col-12">
        <div className="card axs-shadow">
          <div className="card-body">
            <div className="row">
              <div className="col-sm-4 my-auto">
                <div className="media">
                  <RenderProfilePicture image={telehealth.userProfile.profile} circle cached={false} width={50} height={50} className='m-auto' />
                  <div className="media-body ml-3">
                    <h5 className="m0-0">{`${telehealth.userProfile.firstName} ${telehealth.userProfile.lastName}`}</h5>
                    <span className="text-muted">{telehealth.userProfile.gender === 'm' ? 'Male' : 'Female'}, {moment(telehealth.userProfile.dateOfBirth).format('L')}</span>
                  </div>
                </div>
              </div>

              <div className="col-sm-5">
                <strong>{telehealth.questionnaire.resource.title}</strong><br />
                <strong>Date:</strong> {moment(telehealth.appointmentDate.date).format('MM/DD/YYYY hh:mm A')}<br />
                <strong>Type:</strong> {telehealth.telemedicineType === 'video' ? 'Real-Time Video' : 'Asynchronous'}
              </div>

              <Can I="room-access" a="telehealth">
                <div className="col-sm-3 text-center pr-0 my-auto">
                  <Link className="btn btn-success" to={`/telehealth/${telehealth.id}`}>Join</Link>
                </div>
              </Can>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 mt-3 ml-2">
        <div className="row">
          <div className="col-6">
            <h4>Questions</h4>
          </div>
        </div>
      </div>

      {/* Questionnaire */}
      <div className="col-9 mt-3">
        <div className="card axs-shadow">
          <div className="card-body">
            <Tabs defaultActiveKey="questions">
              <Tab eventKey="questions" title="Questions">
                <DataTable
                  noHeader
                  noTableHead
                  columns={columns}
                  data={this.state.data}
                  customStyles={{ cells: { style: { fontSize: '14px', paddingTop: '1em', paddingBottom: '1em' } } }}
                />
              </Tab>
              <Tab eventKey="hpi" title="HPI" className='pt-3'>
                <div className="lead pt-3 px-2" style={{ fontSize: "1em" }}>
                  {this.props.telehealth.questionnaireResponse.hpi || <div className='text-center'>No HPI Available</div>}
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>

      {/* Side Bar */}
      <div className="col-3 pl-1 mt-3 pr-4">
        <DownloadLink telehealth={telehealth} icon={false} block />
      </div>
    </div>
  }
}

const mapStateToProps = state => {
  return {
    isRetrieving: state.telehealth.isRetrieving,
    telehealth: state.telehealth.details
  }
}

export default connect(mapStateToProps)(View);